import touchEventMixins from "../mixin/touchEventMixins";

export default {
  name: "english-answer",
  props: {
    question: Object,
    bgColors: Object,
    bool : Object,
    currentPage: Number,
    examFlameHeight: Function,
    selectMultipleItem: Function,
    undoSelection: Function,
    clearAllSelection: Function,
    drag: Function,
    dragging : Function,
    dragstop: Function,
    checkAnswer: Function,
    disableUsedAnswers: Function,
  },
  mixins: [touchEventMixins],
};
